import { observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import { ActionButton, classNamesFunction, css } from 'office-ui-fabric-react';
import { Calendar } from 'office-ui-fabric-react/lib/Calendar';
import React, { Component } from 'react';

const styles = {
  actionBar: [
    'ms-actionBar',
    {
      selectors: {
        '.ms-Button': {
          marginTop: '-5px',
          marginLeft: '10px',
          marginBottom: '10px',
        },
      },
    },
  ],
};

const getClassNames = classNamesFunction();
const classNames = getClassNames(styles, {});

@observer
export default class CustomCalendar extends Component {
  handleNow = () => {
    const { onClickNow, onDismiss, timezone } = this.props;

    if (onClickNow) {
      const now = !timezone ? moment() : moment.utc().tz(timezone);
      const hour = now.hour();
      const minute = Math.floor(now.minute() / 15) * 15;
      const value = now.hour(hour).minute(minute).second(0);

      onClickNow(new Date(value.format("YYYY-MM-DD HH:mm:ss")));
    }

    if (onDismiss) onDismiss();
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <Calendar {...this.props} />
        <div className={css(classNames.actionBar)}>
          <ActionButton
            iconProps={{ iconName: 'Running' }}
            onClick={this.handleNow}
          >
            {t('Now')}
          </ActionButton>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/RoundSection/Calendar.jsx